<template>
  <!-- 公用组件-选择、新增信息输入框  -->
  <div class="MaInput">
    <el-input
      id="input1"
      ref="input"
      size="mini"
      v-model="value1"
      :placeholder="placeholder"
      :disabled="disabled"
      @dblclick.native="clickclose"
      @click.native="clicknative"
      @focus="doFocus"
      @blur="doBlur"
      @input.native="regrexp(value)"
      @keydown.down.native="downkey($event)"
      @keydown.up.prevent.native="upkey($event)"
      @keydown.enter.native="enterkey($event)"
      :class="icon?'cursorpointer':''"
    >
      <span slot="prefix" class="label_sty" :class="isMust?'isMust':''">{{labelName}}</span>
      <i slot="suffix" v-if="icon" @click="clickclose" class="el-input__icon el-icon-search"></i>
    </el-input>
    <!-- <div v-if="isMust&&(error)" class="invalid-feedbac">{{error}}</div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 值字段
      value1: this.value,
      errors: this.error,
      serror: ""
    };
  },
  props: {
    error: {
      type: String,
      default: ""
    }, //验证不正确提示
    icon: {
      type: Boolean,
      default: false
    },
    reg: {
      type: String,
      default: "text"
    },
    isMust: {
      type: Boolean,
      default: false
    },
    disabled: Boolean,
    placeholder: String,
    // 输入框数据
    value: [String, Number],
    labelName: [String],
    // 是否可输入
    reg: {
      type: String,
      default: "text"
    }
  },
  watch: {
    value: {
      handler: function(newVal, oldVal) {
        this.value1 = this.value;
      }
    },
    value1: {
      handler: function(newVal, oldVal) {
        this.$emit("dateChange", this.value1);
      }
    }
  },
  methods: {
    // $emit('')
    clicknative() {
      this.$emit("clicknative");
    },
    // 双击输入框
    clickclose() {
      this.$emit("ChoiceClick");
    },
    // 按上键
    upkey(e) {
      this.$emit("preFocus");
    },
    // 按下键
    downkey(e) {
      this.$emit("nextFocus");
    },
    // 回车回调
    enterkey() {
      this.$emit("nextFocus");
      // this.$refs.input.blur();
    },
    // 输入框输入正则验证input
    regrexp(val) {
      switch (this.reg) {
        case "text": //任意值
          break;
        case "float": //小数
          this.value1 = this.value1.replace(
            /^\D*(\d*(?:\.\d{0,6})?).*$/g,
            "$1"
          );
          break;
        case "integer": //正整数
          this.value1 = this.value1.replace(/[^\d]/g, "");
          if (!this.value1) {
            this.serror = "";
          } else {
            this.serror = "";
            return true;
          }
          break;
        case "phone": //手机号
          if (!this.value1) {
            this.serror = "";
          } else if (!/^1[345678]\d{9}$/.test(this.value1)) {
            this.serror = "请输入正确是手机号";
          } else {
            this.serror = "";
            return true;
          }
          break;
        case "empty": //任意值  但不能为空
          if (!this.value1) {
            this.serror = "";
          } else {
            this.serror = "";
            return true;
          }
          break;
        case "Man":
          if (!this.value1) {
            this.serror = "";
          } else if (!/[\u4E00-\u9FA5]/g.test(this.value1)) {
            this.serror = "可以输入除汉字以外的任意字符";
            // return true;
          } else {
            this.serror = "";
            return true;
          }
          break;
        default:
          break;
      }
    },
    // 聚焦触发全输入框内容
    doFocus() {
      event.currentTarget.select();
    },
    // 失去焦点，隐藏选择框
    doBlur() {
      this.rowIndex = 0; //重置索引
    }
  },
  mounted() {}
};
</script>

<style lang="less">
.MaInput {
  .label_sty {
    color: #333;
    font-size: 12px;
    padding: 0 5px;
    height: 100%;
    line-height: 28px;
    font-weight: bold;
    display: inline-block;
  }
  .el-input--prefix .el-input__inner {
    padding-left: 75px;
    background-color: #fff;
  }

  .isMust::after {
    content: "*";
    color: red;
  }
  .el-input.is-disabled .el-input__icon {
    cursor: pointer;
  }
  .invalid-feedbac {
    font-size: 12px;
    color: #f56c6c;
    margin-left: 7px;
    height: 16px;
    line-height: 16px;
    position: absolute;
  }
  .cursorpointer {
    cursor: pointer;
    .el-input__inner {
      cursor: pointer;
    }
  }
  .el-input.is-disabled .el-input__inner {
    color: #000;
  }
  input[type="text"]::-webkit-input-placeholder {
    /* WebKit browsers /
color: #999;
}
input[type=text]:-moz-placeholder { / Mozilla Firefox 4 to 18 /
color: #999;
}
input[type=text]::-moz-placeholder { / Mozilla Firefox 19+ /
color: #999;
}
input[type=text]:-ms-input-placeholder { / Internet Explorer 10+ */
    color: red;
    // text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Input/IncreaseChange/Increaseinput.vue